export default "__VITE_ASSET___muVP0lg__"